const PersonalDetails = ({ application }) => {
  return (
    <div className="bg-[#131313] rounded-l-lg p-4">
      <div className="flex items-center mb-4 gap-2">
        <svg
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.625 12.375C14.4141 12.375 17.5 15.4609 17.5 19.25C17.5 19.9531 16.9141 20.5 16.25 20.5H1.25C0.546875 20.5 0 19.9531 0 19.25C0 15.4609 3.04688 12.375 6.875 12.375H10.625ZM1.875 18.625H15.5859C15.2734 16.1641 13.1641 14.25 10.625 14.25H6.875C4.29688 14.25 2.1875 16.1641 1.875 18.625ZM8.75 10.5C5.97656 10.5 3.75 8.27344 3.75 5.5C3.75 2.76562 5.97656 0.5 8.75 0.5C11.4844 0.5 13.75 2.76562 13.75 5.5C13.75 8.27344 11.4844 10.5 8.75 10.5ZM8.75 2.375C6.99219 2.375 5.625 3.78125 5.625 5.5C5.625 7.25781 6.99219 8.625 8.75 8.625C10.4688 8.625 11.875 7.25781 11.875 5.5C11.875 3.78125 10.4688 2.375 8.75 2.375Z"
            fill="#FFCA20"
          />
        </svg>

        <h3 className="text-white text-lg">Personal Information</h3>
      </div>

      <div className="space-y-4">
        <div>
          <p className="text-gray-400 text-sm">Full Name</p>
          <p className="text-white">{application?.user?.name || "N/A"}</p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Phone Number</p>
          <p className="text-white">
            {application?.user?.phoneNumber || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Email ID</p>
          <p className="text-white">{application?.user?.email || "N/A"}</p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Address</p>
          <p className="text-white">
            {application?.user?.permanentAddress?.street || "N/A"}
          </p>
          <p className="text-white">
            {application?.user?.permanentAddress?.city || "N/A"},
            {application?.user?.permanentAddress?.state || "N/A"}
          </p>
          <p className="text-white">
            {application?.user?.permanentAddress?.pincode || "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
